/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterContratoGestor(contratoId) {
        return axiosJwt
            .get(`${api}/processos/contratogestor/${contratoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFaseContratoGestor(contratoId, faseId) {
        return axiosJwt
            .get(`${api}/processos/contratogestor/${contratoId}/fases/${faseId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoResponsavel(comprometimentoId) {
        return axiosJwt
            .get(
                `${api}/processos/comprometimentoresponsavel/${comprometimentoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    finalizarAvisosVencimentoContrato(finalizarDto) {
        return axiosJwt
            .post(
                `${api}/processos/finalizaravisosvencimentocontrato`,
                finalizarDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    finalizarAvisosVencimentoFaseContrato(finalizarDto) {
        return axiosJwt
            .post(
                `${api}/processos/finalizaravisosvencimentofasecontrato`,
                finalizarDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    finalizarAvisosSaldoContrato(finalizarDto) {
        return axiosJwt
            .post(`${api}/processos/finalizaravisossaldocontrato`, finalizarDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    finalizarAvisosSaldoFaseContrato(finalizarDto) {
        return axiosJwt
            .post(`${api}/processos/finalizaravisossaldofasecontrato`, finalizarDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    finalizarAvisosContratoSemMovimentacao(contratoId) {
        return axiosJwt
            .patch(
                `${api}/processos/finalizaravisoscontratosemmovimentacao/${contratoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    finalizarAvisosComprometimentoSemRegistroPagamento(comprometimentoId) {
        return axiosJwt
            .patch(
                `${api}/processos/finalizaravisoscomprometimentosemregistropagamento/${comprometimentoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
